import { schema as schemas } from 'normalizr'
import { CallApi, RequestOptions } from '@signavio/kraken'

import { getCurrentLoginToken } from '../../callApi'

export const collection = 'files'

export const schema = new schemas.Entity(collection)

type FetchQueryType = {
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: FetchQueryType) =>
    callApi(`${apiBase}/files/${id}`, schema)

type CreateRequestParamsType = {
  endpoint?: string
}

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, file: File, { endpoint }: CreateRequestParamsType) => {
    const formData = new FormData()

    const token = getCurrentLoginToken()
    if (token) {
      // only append the Authorization token if you have a user that is logged in
      // the back-end doesn't expect a token for registrations
      formData.append('Authorization', token)
    }
    formData.append('files', file)

    const options = {
      method: 'POST',
      body: formData,
    } as RequestOptions

    // the upstream components define the complete endpoint incl. the prefix /api/v1
    return callApi(endpoint ? endpoint : `${apiBase}/files`, schema, options)
  }
